// extracted by mini-css-extract-plugin
module.exports = {"picker":"ColorPicker_picker__Zu1Dn","fadeIn":"ColorPicker_fadeIn__1pJSk"};